module.exports = __webpack_public_path__ + "static/media/logo-presto.789b24ff.png";